import { graphql, useStaticQuery } from 'gatsby';

import { isActiveSeason } from '../../utils';

export const useSettings = (): Queries.Maybe<Queries.Squidex_Settings> => {
  const data = useStaticQuery<Queries.Query>(query);

  return data.squidex.findSettingsSingleton;
};

export const useIsActiveSeason = (
  seasons: Queries.Maybe<readonly Queries.Squidex_Seasons[]> | undefined,
): boolean => {
  const settings = useSettings();
  return isActiveSeason(seasons, settings);
};

const query = graphql`
  query useSettingsQuery {
    squidex {
      findSettingsSingleton {
        flatData {
          season {
            flatData {
              alias
            }
          }
        }
      }
    }
  }
`;
